import React from "react";
import "./About.css";
import CommonBanner from "../../components/CommonBanner/CommonBanner";
import AboutSection1 from "../../components/AboutSection1/AboutSection1";

export default function About() {
  return (
    <>
      {/*  Banner section with text "About Livasa" */}
      <CommonBanner bannerText="About Livasa" />

      {/* Decorative honeycomb section */}
      <div className="honeycomb"></div>

      {/* Main content container for the About page */}
      <div className="container">
        {/* About section component */}
        <AboutSection1 />
      </div>
    </>
  );
}

